import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Media } from "./media";
import { Category } from "./category";
import { Genre } from "./genre";

export class Artist extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Artist' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    id: string

    @JsonProperty({ type: 'string' })
    name: string

    @JsonProperty({ type: 'string?' })
    picture_url?: string

    @JsonProperty({ type: 'string?' })
    banner_url?: string

    @JsonProperty({ type: 'string?' })
    artist_description?: string

    @JsonProperty({ type: 'string' })
    slug: string

}



// WEBPACK FOOTER //
// ./src/api/src/models/artist.ts